'use client';

import dayjs, { extend } from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';

extend(updateLocale);

dayjs.updateLocale('en', {
  weekStart: 1,
});
